import React, { useState } from "react";
import { FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaGlobe, FaLaptopCode, FaSyncAlt, FaDatabase, FaExchangeAlt, FaHospital, FaNetworkWired, FaChartLine, FaCogs, FaHeartbeat, FaRobot, FaUsers, FaTools, FaFingerprint, FaBell, FaChartPie, FaUserCog, FaLanguage, FaBolt, FaMoneyCheckAlt, FaStore } from "react-icons/fa";
import { FaUserShield, } from "react-icons/fa";
import Medpalm from "../../../assests/service/Interoperability.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
      "title": "Healthcare Interoperability Strategy Development",
      "description": "Develop a comprehensive strategy to enhance healthcare data exchange across various systems, ensuring seamless communication between hospitals, clinics, and third-party applications. This strategy focuses on accelerating client onboarding, reducing integration costs, and ensuring HIPAA compliance. By aligning with industry standards such as FHIR and HL7, organizations can achieve greater interoperability, improved patient data accessibility, and more efficient workflows."
    },
    {
      "title": "Healthcare Interoperability Roadmapping",
      "description": "Create a structured and actionable roadmap to guide healthcare organizations through their interoperability journey. This includes defining clear milestones, setting technology adoption strategies, and outlining best practices for seamless system integrations. The roadmap ensures alignment with regulatory requirements, reduces implementation risks, and provides a step-by-step approach to achieving a fully connected healthcare ecosystem."
    },
    {
      "title": "Healthcare Data Mapping & Workflow Documentation",
      "description": "Ensure accurate and efficient data flow between disparate healthcare systems by implementing structured data mapping techniques. This process includes standardizing data formats, eliminating redundancies, and improving accessibility across multiple platforms. Additionally, workflow documentation helps healthcare providers optimize clinical and administrative processes, minimize errors, and enhance patient care coordination through well-defined data exchange protocols."
    },
    {
      "title": "Healthcare Interoperability Training & Education",
      "description": "Provide healthcare professionals, IT teams, and administrators with specialized training on interoperability standards such as HL7, FHIR, and DICOM. Training covers regulatory compliance, implementation strategies, data governance, and security best practices. By equipping teams with the necessary knowledge, organizations can successfully implement and maintain interoperability initiatives, ensuring improved system connectivity and patient data management."
    },
    {
      "title": "EHR Integration Planning",
      "description": "Develop a strategic plan for integrating Electronic Health Record (EHR) systems with other healthcare platforms, including laboratory systems, pharmacy databases, and third-party applications. The planning process focuses on ensuring secure, scalable, and efficient data exchange while adhering to interoperability standards like FHIR and HL7. A well-structured EHR integration enhances clinical workflows, improves data accuracy, and provides a unified patient record for better healthcare decision-making."
    }
  ]
  
const features = [
    // { icon: <FaSync />, text: "Automated data synchronization across multiple healthcare systems." },
    // { icon: <FaNetworkWired />, text: "Seamless connectivity between hospitals, clinics, and third-party providers." },
    // { icon: <FaDatabase />, text: "Unified data storage that eliminates redundancy and improves accessibility." },
    { icon: <FaUsers />, text: "Interoperability between government, private healthcare, and research institutions." },
    { icon: <FaTools />, text: "Customizable integration tools for different healthcare applications." },
    { icon: <FaRobot />, text: "AI-powered interoperability for predictive analysis and automation." },
    { icon: <FaClipboardList />, text: "Unified patient records with complete treatment history and medications." },
    { icon: <FaFingerprint />, text: "Biometric authentication support for secure and seamless access." },
    { icon: <FaBell />, text: "Automated alerts and notifications for real-time patient updates." },
    { icon: <FaChartPie />, text: "Data-driven insights for improved decision-making and healthcare policies." },
    { icon: <FaUserCog />, text: "User-controlled interoperability settings for data privacy management." },
    { icon: <FaLanguage />, text: "Multilingual support for cross-border healthcare interoperability." },
    { icon: <FaBolt />, text: "Faster response times with high-performance data exchange systems." },
    { icon: <FaMoneyCheckAlt />, text: "Integration with insurance providers for real-time claim processing." },
    { icon: <FaStore />, text: "Marketplace compatibility for healthcare apps and medical tools." }
];

const benefits = [
    { text: "Seamless healthcare data exchange between providers and payers.", icon: <FaExchangeAlt className="text-[#2a627a] text-2xl" /> },
    { text: "Improves care coordination and patient outcomes.", icon: <FaUserMd className="text-[#2a627a] text-2xl" /> },
    { text: "Enhances efficiency in hospitals and clinics.", icon: <FaHospital className="text-[#2a627a] text-2xl" /> },
    { text: "Supports secure and compliant data sharing.", icon: <FaNetworkWired className="text-[#2a627a] text-2xl" /> },
];

const consentItems = [
    { icon: <FaExchangeAlt />, text: "Facilitates seamless data exchange between different healthcare systems." },
    { icon: <FaNetworkWired />, text: "Connects multiple platforms, ensuring smooth communication across networks." },
    { icon: <FaDatabase />, text: "Enables secure access and sharing of patient records across providers." },
    { icon: <FaLaptopCode />, text: "Supports integration with APIs and electronic health record (EHR) systems." },
    { icon: <FaUserShield />, text: "Ensures data privacy and security while enabling information sharing." },
    { icon: <FaSyncAlt />, text: "Keeps patient data synchronized and updated across all connected platforms." },
    { icon: <FaChartLine />, text: "Improves decision-making through real-time access to comprehensive health data." },
    { icon: <FaGlobe />, text: "Allows cross-border data exchange while maintaining regional compliance." },
    { icon: <FaFileMedical />, text: "Enhances care coordination by providing doctors with complete patient histories." },
    { icon: <FaCogs />, text: "Automates workflows by integrating different healthcare applications and services." },
    { icon: <FaHeartbeat />, text: "Supports remote patient monitoring by securely transmitting health data in real-time." },
    { icon: <FaRobot />, text: "Enhances AI-driven diagnostics and predictive healthcare analytics through data interoperability." }

];

const Interoperability = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Interoperability   </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        Enables secure and efficient data exchange across healthcare systems while ensuring user privacy and regulatory compliance.
                    </p>
                </div>

                {/* What is Interoperability? */}
                <section className="mt-8 flex flex-col md:flex-row bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Interoperability in Healthcare" className="rounded-2xl hover:shadow-2xl w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Interoperability?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Interoperability in healthcare refers to the seamless exchange of patient data across different systems, ensuring secure communication between hospitals, clinics, and electronic health record (EHR) platforms. It enhances care coordination, reduces errors, and ensures compliance with data privacy regulations.
                        </p>
                    </div>
                </section>


                {/* Role of Interoperability */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Interoperability
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-[#2a627a] p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>

    );
};

export default Interoperability;
